import { Link, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useEffect } from "react";
import { getProductListAsync } from "../../../../../app/slices/productTypesSlice/productTypesSlice";
import { CircularProgress } from "@mui/material";

export const ShopAll = () => {
  const dispatch = useAppDispatch();
  const productList = useAppSelector(
    (state) => state.productTypesState.productTypes
  );

  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getProductListAsync());
  }, []);

  return (
    <>
      <ResponsiveAppBar />
      <div
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
          color: "var(--main)",
          backgroundColor: "var(--white)",
        }}
      >
        <div className="tf-page-title style-3">
          <div className="container-full">
            <div className="heading text-center">Shop by Category</div>
          </div>
        </div>
        <section className="flat-spacing-1">
          {productList?.loader ? (
            <div className="container">
              <div
                id="parent"
                className="tf-brands-source-linklist d-grid"
                style={{ minHeight: "50vh" }}
              >
                {" "}
                <CircularProgress
                  style={{
                    position: "absolute",
                    // top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="container">
              <div id="parent" className="tf-brands-source-linklist d-grid">
                {productList?.data?.map((item: any, index: any) => {
                  return (
                    <Link
                      to={{
                        pathname: `/product/${item?.category_code}`,
                      }}
                      key={index}
                    >
                      <div className="tf_filter_123 tf-filter-item tf-tab-content">
                        <div
                          className="tf-filter-item-inner"
                          style={{ alignItems: "center" }}
                        >
                          <div className="tf-titles-filter">
                            <img
                              className="rounded-full"
                              width="120"
                              style={{ height: "145px", width: "145px" }}
                              data-src={`${process.env.REACT_APP_API_URL}${item?.standard_image}`}
                              src={`${process.env.REACT_APP_API_URL}${item?.standard_image}`}
                              alt="Fresh Cream Cakes"
                            />
                          </div>
                          <div className="tf-content-brands">
                            <div
                              className="tf-item-inner"
                              style={{
                                marginTop: "10%",
                                alignContent: "center",
                              }}
                            >
                              <span>
                                <b> {item?.category_name}</b>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          )}
        </section>
        <Footer />
      </div>
    </>
  );
};
